import React from "react";
import { EpgEventDetailImage, EpgEventDetailOverride } from "../../../../../models/epg/Models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";

interface ImageUploadFieldProps {
    images: EpgEventDetailImage[],
    isEditMode: boolean,
    title: string
    updateField: <K extends keyof EpgEventDetailOverride>(key: K, value: EpgEventDetailOverride[K]) => void
}

const ImageUploadField = ({ images, isEditMode, title, updateField } : ImageUploadFieldProps) => {

    const removeImage = (index: number) => {
        const newImages = [ ...images ];
        newImages.splice(index, 1);
        updateField("images", newImages);
    };

    return (
			<>
        <div className = {`flex flex-row items-center gap-4 justify-between`}>
            <p className = {"text-slate-500 font-bold text-lg"}>Images</p>
            <button
                className = {`flex flex-row gap-1 items-center bg-blue-800 dark:bg-indigo-400 shadow-md border p-1 rounded-md ${isEditMode ? "block" : "hidden"}`}
            >
                <FontAwesomeIcon icon = {faArrowUpFromBracket} size = "1x" fixedWidth className={`text-white`} />
                <p className={`text-white`}>Upload Images</p>
            </button>
        </div>
        <div className = {`mt-4 flex flex-wrap flex-row gap-2`}>
            {
                images && images.length > 0 ?
                    images.map((image, index) => (
                        <div className = {`relative w-48 h-48 rounded-md bg-gray-200 overflow-hidden`}
                             key = {image.url}
                        >
                            <button
                                className = {`absolute right-1 top-1 bg-red-400 p-2 rounded-md ${isEditMode ? "block" : "hidden"}`}
                                onClick = {() => {
                                    removeImage(index);
                            	}}
                            >
                                <FontAwesomeIcon icon = {faTrashCan} size = "1x" fixedWidth className = {`text-white`} />
                            </button>
                            <img src = {image.url}
                                 alt = {`Image ${index} of ${title}`}
                                 className = "w-full h-full object-cover"
                            />
                        </div>
                    )) :
                    <div className = {`p-4 ${isEditMode ? "hidden" : "block"}`}>
                        <p className = {`font-bold text-slate-500`}>No Images Added Yet.</p>
                    </div>
            }
        </div>
			</>
    );
};

export default ImageUploadField;